/*import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {
  public text: any;

    private regex: RegExp = new RegExp(/^-?[0-9]+(\.[0-9]*){0,1}$/g);
    private specialKeys: Array<string> = ['Backspace', 'Tab'];

    constructor(private el: ElementRef) {
    }
    @HostListener('keypress', ['$event'])
    onKeyDown(event: KeyboardEvent) {
      if (this.specialKeys.indexOf(event.key) !== -1) {
        return;
      }
      const current: string = this.el.nativeElement.value;
      const next: string = current.concat(event.key);

      if(next.includes('.')){
        if(this.text == next){
          event.preventDefault();
        }
        this.text= next;
      }
      if ((next && !String(next).match(this.regex))) {
        event.preventDefault();
      }
    } 

}
*/
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {

  // allows: -10, 10, -10.5, .5, -0.25
  private regex: RegExp = /^-?\d*\.?\d*$/;

  constructor(private el: ElementRef) {}

  @HostListener('input')
  onInputChange() {
    const value: string = this.el.nativeElement.value;

    // If value does not match allowed numeric pattern, trim last char
    if (!this.regex.test(value)) {
      this.el.nativeElement.value = value.slice(0, -1);
    }
  }
}
